export enum Audience {
  VENTURE_APPLICATION = 'VENTURE_APPLICATION',
  MENTOR_APPLICATION = 'MENTOR_APPLICATION',
  FOUNDER_APPLICATION = 'FOUNDER_APPLICATION',
  VENTURE_ADDITIONAL_INFO = 'VENTURE_ADDITIONAL_INFO',
  MENTOR_ADDITIONAL_INFO = 'MENTOR_ADDITIONAL_INFO',
  FOUNDER_ADDITIONAL_INFO = 'FOUNDER_ADDITIONAL_INFO',
}
